<template>
    <div class="table-container">
        <el-table
            :data="specialists"
            v-loading="isLoading"
            size="small"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    {{props.row.brief||'-暂无简介-'}}
                </template>
            </el-table-column>
            <el-table-column
                prop="domain.name"
                label="领域"
                show-overflow-tooltip
                width="120"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
            >
            <template slot-scope="props">
                <div class="name">
                    <el-popover
                        v-if="props.row.avatar"
                        placement="right"
                        trigger="click">
                        <el-image :src="props.row.avatar.path" fit="contain" style="max-width:300px"/>
                        <el-image :src="props.row.avatar.path" size="small" fit="contain" shape="square" slot="reference"/>
                    </el-popover>
                    <el-avatar icon="el-icon-user-solid" v-else size="small" shape="square"/>
                    <span>{{props.row.name}}</span>
                </div>
            </template>
            </el-table-column>
            <el-table-column
                prop="phone"
                label="电话"
                width="160"
            >
            </el-table-column>
            <el-table-column
                prop="email"
                label="邮箱"
                width="260"
            >
            </el-table-column>
            <el-table-column
                prop="is_available"
                label="可约见"
                width="90"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="top"
                label="置顶"
                width="90"
                :formatter="boolFormatter"
            ></el-table-column>
            <el-table-column
                prop="created_at"
                width="160"
                label="创建时间"
                align="center"
                :formatter="unixFormatter"
            ></el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="140"
            >
                <template slot-scope="scope">
                    <el-button
                        @click="edit(scope.row)"
                        type="text"
                        size="mini"
                    >编辑</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <ox-safe-button
                        @confirm="remove(scope.row)"
                        type="text"
                        size="small"
                    >删除</ox-safe-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="onPageChange"
                :page-size="pagination.size"
                :current-page="pagination.current"
                :total="pagination.total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { pageMixin, fmtMixin } from "@/ox/Mixins";
import OxSafeButton from '@/ox/components/OxSafeButton';

export default {
    name: "ProductTable",
    mixins: [pageMixin, fmtMixin],
    components:{
        OxSafeButton
    },
    data: function() {
        return {
            page: 1,
            isLoading: false,
            specialists: []
        };
    },

    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.isLoading = true;
            const currentPage = page || this.page;
            const query = new window.BaaS.Query();
            const {filter} = this.$parent;
            if(filter.domain){
                query.compare('domain', '=', filter.domain);
            }
            if(filter.company){
                query.compare('company', '=', filter.company);
            }
            if(filter.keyword){
                query.contains('name', filter.keyword);
            }
            this.$ox
                .service("specialist")
                .find(query, {
                    page: currentPage,
                    withCount: true,
                    expand:['domain'],
                    orderBy: ["-top", "-updated_at"]
                })
                .then(res => {
                    this.isLoading = false;
                    this.pagination.size = res.meta.limit;
                    this.pagination.total = res.meta.total_count;
                    this.pagination.current = currentPage;
                    this.page = currentPage;
                    this.specialists = res.objects;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onPageChange(page) {
            this.loadData(page);
        },
        edit(row) {
            this.$parent.$refs.dialog.show(row)
        },
        remove(row){
            this.$ox.service('specialist').delete(row.id).then(()=>{
                this.specialists = this.specialists.filter(specialist=>specialist.id!==row.id)
                this.$notify.success({
                    title: '操作成功',
                    message: `专家"${row.name}"信息已删除`
                });
            })
        }
    }
};
</script>

<style scoped>
.name{
    display: flex;
    justify-content:flex-start;
    align-items:center;
}
.name .el-image{
    width:32px;
    height:32px;
    margin-right:10px;
    text-align: center;
}
.name .el-avatar{
    margin-right:10px;
}
.name img{
    border-radius: 6px;
}
</style>
